import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coachtraining-certification',
  templateUrl: './coachtraining-certification.component.html',
  styleUrls: ['./coachtraining-certification.component.scss']
})
export class CoachtrainingCertificationComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Capacitação
   */
  public departmentId: string = '26';

  constructor() { }

  ngOnInit(): void {
  }

}
